/**
 * Update or set Query parameter
 * @param  {string} key Key to set/update.
 * @param  {string} value Value of key.
 * @param  {string|null} url current href, can be null.
 */
export function updateQueryString(key, value) {
  var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!url) url = window.location.href;
  var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
    hash;
  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) {
      return url.replace(re, '$1' + key + '=' + value + '$2$3');
    } else {
      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1];
      }
      return url;
    }
  } else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = hash[0] + separator + key + '=' + value;
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1];
      }
      return url;
    } else {
      return url;
    }
  }
}

/**
 * Updates window history through replaceState
 * @param  {string} url URL to be updated to.
 */
export function replaceQueryWindowState(url) {
  window.history.replaceState(window.history.state, '', url);
}

/**
 * Retrieves query param
 * @param  {string} paramName wanted Query param name.
 */
export default function checkQueryParams(paramName) {
  var params = new URLSearchParams(window.location.search);
  return params.get(paramName);
}

/**
 * Retrieves predefined query param
 * @param  {string} paramName wanted Query param name.
 * @param  {string} predefinedQuery predefined query params.
 */
export function checkPredefinedQueryParams(paramName, predefinedQuery) {
  var params = new URLSearchParams(predefinedQuery);
  return params.get(paramName);
}